import type { DependencySection } from '@cli-types/next-adapter/init.js'
import type { ProjectPackageJson } from '@cli-types/next-adapter/utils.js'
import { CLI_PACKAGE_NAME } from '@cli-constants/cli.js'

export function getDeclaredCliDependency(
  pkg: ProjectPackageJson
): { section: DependencySection; spec: string } | null {
  const devDependency = pkg.devDependencies?.[CLI_PACKAGE_NAME]
  if (typeof devDependency === 'string' && devDependency.length > 0) {
    return { section: 'devDependencies', spec: devDependency }
  }

  const dependency = pkg.dependencies?.[CLI_PACKAGE_NAME]
  if (typeof dependency === 'string' && dependency.length > 0) {
    return { section: 'dependencies', spec: dependency }
  }

  return null
}
